import styled from '@emotion/styled'
import { Caption, Text, Title } from 'components/Typography'
import { BREAKPOINTS } from 'utils/styled'

export const SWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  @media ${BREAKPOINTS.MD.max} {
    align-items: flex-start;
    flex-direction: column-reverse;
  }
`

export const STextWrapper = styled.div`
  flex: 1;
  margin-right: 4rem;

  @media ${BREAKPOINTS.MD.max} {
    margin-right: 0;
  }
`

export const SCaption = styled(Caption)`
  color: var(--c-blue500);

  @media ${BREAKPOINTS.MD.max} {
    margin-bottom: 0.5rem;
  }
`

export const STitle = styled(Title)`
  margin-bottom: 1.5rem;
`

export const SText = styled(Text)`
  margin-bottom: 2rem;
`

export const SImageWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;

  & > picture {
    width: 100%;
  }
  & > img,
  & > picture > img {
    width: 100%;
    max-height: 25rem;
    object-fit: contain;
  }

  @media ${BREAKPOINTS.MD.max} {
    margin-bottom: 1.5rem;
    width: 50%;
  }
`
